import React from 'react';
import styled from 'styled-components';
import Accordion from '../../Accordion';

const StyledLi = styled.li`
  font-size: 1rem;
  line-height: 1.5rem;
`;

const StyledOl = styled.ol`
  margin-top: 0.25rem;
`;

const TermsAndConditionsAccordion = () => {
  return (
    <Accordion title="Terms &amp; conditions">
      <StyledOl>
        <StyledLi>Denominated in Singapore dollars</StyledLi>
        <StyledLi>
          Not redeemable for cash, store credit or other gift vouchers (including paper gift
          vouchers or gift cards)
        </StyledLi>
        <StyledLi>Not valid for lottery products</StyledLi>
        <StyledLi>Not valid for redemption at Cheers and FairPrice Xpress outlets</StyledLi>
        <StyledLi>Not valid for purchases from Marketplace sellers on FairPrice Online</StyledLi>
        <StyledLi>Not valid for checkout via Scan & Go</StyledLi>
        <StyledLi>Non-refundable and non-exchangeable</StyledLi>
        <StyledLi>Not replaceable if lost, stolen or damaged</StyledLi>
        <StyledLi>Expiry date is final</StyledLi>
        <StyledLi>Unused value is not refundable</StyledLi>
        <StyledLi>
          Not valid for offset of service or delivery fees on FairPrice Online orders
        </StyledLi>
        <StyledLi>
          Other operational restrictions as published by NTUC FairPrice from time to time
        </StyledLi>
      </StyledOl>
    </Accordion>
  );
};

export default TermsAndConditionsAccordion;
